import { HTTP } from '../http-common';
import { GAME_VERSION as insiderClientVersion } from '../autogen/version';
import { REVISION_HASH as insiderClientRevisionHash } from '../autogen/version';
import notifier from '../notifier';
import { isStageOrProd } from '../util';

class VersionChecker {
  start() {
    this.loadInsiderServerVersion(this.onInsiderServerVersionLoaded);
  }

  loadInsiderServerVersion(callback) {
    HTTP.get('/insider_server_public_info')
    .then(response => {
      const insiderServerInfo = response.data.data;
      callback(insiderServerInfo, null);
    })
    .catch(err => {
      callback(null, err);
    });
  }

  onInsiderServerVersionLoaded(insiderServerInfo, err) {
    if(err !== null) {
      notifier.showError('Can not check insider. ' + err.toString(), {sender: this, route: 'any'});
      return;
    }

    const insiderServerVersion = insiderServerInfo.gameVersion;
    if(insiderClientVersion !== insiderServerVersion) {
      let errorMessage = `Insider is in invalid state. `;
      errorMessage += `Insider client version: ${insiderClientVersion}. `;
      errorMessage += `Insider server version: ${insiderServerVersion}. `;
      errorMessage += 'Versions must be equal.'

      notifier.showError(errorMessage, {sender: this, route: 'any'});
      return;
    }

    if(isStageOrProd()) {
      const insiderServerRevisionHash = insiderServerInfo.revisionHash;
      if(insiderClientRevisionHash !== insiderServerRevisionHash) {
        let errorMessage = `Insider is in invalid state. `;
        errorMessage += `Insider client revision hash: ${insiderClientRevisionHash}. `;
        errorMessage += `Insider server revision hash: ${insiderServerRevisionHash}. `;
        errorMessage += 'Revision hashes must be equal.'
        notifier.showError(errorMessage, {sender: this, route: 'any'});
        return;
      }
    }
  }
}

const versionChecker = new VersionChecker();
export default versionChecker;
